export const ConvertToTitleCase =(str)=>{
    let string = str === undefined ? "" : str
    return str?.toLowerCase()?.replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
      
}